import { get } from "lodash";
import { useState } from "react";
import Slider from "./Slider";

const getDescription = (categoriesConfig, categoryId, level) => {
  // Look up by category ID (not value) since config is keyed by ID
  const configText = get(categoriesConfig, `${categoryId}.${level}.text`, null);
  return configText || "";
};

const NeedsContent = ({
  categories,
  selectedValues,
  setSelectedValues,
  onClick,
  needsLevels,
  labels,
  categoriesConfig,
  disabled,
  translation,
}) => {
  // Build options from labels
  const options = {};
  for (let i = 1; i <= needsLevels; i++) {
    options[i] = labels[String(i)] || `${translation.NEEDS.DEFAULT_LEVEL} ${i}`;
  }

  // Build marks array
  const marks = Array.from({ length: needsLevels }, (_, i) => i + 1);

  const [description, setDescription] = useState(
    categories.reduce((acc, category) => {
      // Use category.id to look up in config, but store by category.value for display
      acc[category.value] = getDescription(
        categoriesConfig,
        category.id,
        selectedValues[category.value],
      );
      return acc;
    }, {}),
  );

  const handleChange = (category, value) => {
    setDescription((prev) => ({
      ...prev,
      [category.value]: getDescription(categoriesConfig, category.id, value),
    }));
    setSelectedValues((prev) => ({ ...prev, [category.value]: value }));
  };

  return (
    <div className="b2c__needs--content">
      <div className="b2c__needs--slides">
        {categories.map((category) => (
          <div key={category.value} className="b2c__needs--item">
            <div className="b2c__needs--head">
              <div className="b2c__needs--left">
                <img src={category.icon} alt="" />
                <div className="b2c__needs--info">
                  <span>{category.label}</span>
                  <small>{get(description, category.value)}</small>
                </div>
              </div>
            </div>

            <Slider
              marks={marks}
              options={options}
              value={selectedValues[category.value]}
              onClick={(value) => {
                if (!disabled) {
                  handleChange(category, value);
                }
              }}
              disabled={disabled}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

const Needs = ({
  categories = [],
  selectedValues,
  setSelectedValues,
  onClick,
  needsLevels = 3,
  labels = {},
  categoriesConfig = {},
  disabled = false,
  translation,
}) => {
  return (
    <NeedsContent
      categories={categories}
      selectedValues={selectedValues}
      setSelectedValues={setSelectedValues}
      onClick={onClick}
      needsLevels={needsLevels}
      labels={labels}
      categoriesConfig={categoriesConfig}
      disabled={disabled}
      translation={translation}
    />
  );
};

export default Needs;
